"use client";

import HeroBlock, { HeroBlockProps } from "./HeroBlock";
import IntroBlock, { IntroBlockProps } from "./IntroBlock";
import ImageGridBlock, { ImageGridBlockProps } from "./ImageGridBlock";
import ContentBlock, { ContentBlockProps } from "./ContentBlock";
import TwoColumnTextBlock, { TwoColumnTextBlockProps } from "./TwoColumnTextBlock";
import ProductFeatureBlock, { ProductFeatureBlockProps } from "./ProductFeatureBlock";
import CarouselBlock, { CarouselBlockProps } from "./CarouselBlock";
import BrandValuesBlock, { BrandValuesBlockProps } from "./BrandValuesBlock";
import ImpactTextBlock, { ImpactTextBlockProps } from "./ImpactTextBlock";
import ResearchHeaderBlock, { ResearchHeaderBlockProps } from "./ResearchHeaderBlock";
import ArticleSectionBlock, { ArticleSectionBlockProps } from "./ArticleSectionBlock";
import BentoGridBlock, { BentoGridBlockProps } from "./BentoGridBlock";
import AtrFlightSimBlock, { AtrFlightSimBlockProps } from "./AtrFlightSimBlock";
import ProblemSolutionBlock, { ProblemSolutionBlockProps } from "./ProblemSolutionBlock";
import Hero3Block, { Hero3BlockProps } from "./Hero3Block";
import AboutProjectBlock, { AboutProjectBlockProps } from "./AboutProjectBlock";
import AboutProject2Block, { AboutProject2BlockProps } from "./AboutProject2Block";
import ProjectGalleryBlock, { ProjectGalleryBlockProps } from "./ProjectGalleryBlock";
import ProjectVideoBlock, { ProjectVideoBlockProps } from "./ProjectVideoBlock";
import LayoutBlueprintBlock, { LayoutBlueprintBlockProps } from "./LayoutBlueprintBlock";
import TypographyColorsBlock, { TypographyColorsBlockProps } from "./TypographyColorsBlock";
import DesktopShowcaseBlock, { DesktopShowcaseBlockProps } from "./DesktopShowcaseBlock";
import MobileShowcaseBlock, { MobileShowcaseBlockProps } from "./MobileShowcaseBlock";
import SpecsBentoBlock, { SpecsBentoBlockProps } from "./SpecsBentoBlock";
import ProductHeroBlock, { ProductHeroBlockProps } from "./ProductHeroBlock";
import ProblemSolutionCardsBlock, { ProblemSolutionCardsBlockProps } from "./ProblemSolutionCardsBlock";
import AtrHeroBlock, { AtrHeroBlockProps } from "./AtrHeroBlock";
import AtrSpecsDossierBlock, { AtrSpecsDossierBlockProps } from "./AtrSpecsDossierBlock";
import AtrDataPipelineBlock, { AtrDataPipelineBlockProps } from "./AtrDataPipelineBlock";
import AtrParameterGridBlock, { AtrParameterGridBlockProps } from "./AtrParameterGridBlock";
import AtrTrajectoryChartBlock, { AtrTrajectoryChartBlockProps } from "./AtrTrajectoryChartBlock";
import AtrEpilogueBlock, { AtrEpilogueBlockProps } from "./AtrEpilogueBlock";
import GuestiqoHeroBlock, { GuestiqoHeroBlockProps } from "./GuestiqoHeroBlock";
import GuestiqoDossierBlock, { GuestiqoDossierBlockProps } from "./GuestiqoDossierBlock";
import GuestiqoLifecycleBlock, { GuestiqoLifecycleBlockProps } from "./GuestiqoLifecycleBlock";
import GuestiqoDeliverablesBlock, { GuestiqoDeliverablesBlockProps } from "./GuestiqoDeliverablesBlock";
import GuestiqoShowcaseBlock, { GuestiqoShowcaseBlockProps } from "./GuestiqoShowcaseBlock";
import GuestiqoTechStackBlock, { GuestiqoTechStackBlockProps } from "./GuestiqoTechStackBlock";
import GuestiqoPhilosophyBlock, { GuestiqoPhilosophyBlockProps } from "./GuestiqoPhilosophyBlock";
import GuestiqoTimelineBlock, { GuestiqoTimelineBlockProps } from "./GuestiqoTimelineBlock";
import GuestiqoMetricsBlock, { GuestiqoMetricsBlockProps } from "./GuestiqoMetricsBlock";
import GuestiqoGalleryBlock, { GuestiqoGalleryBlockProps } from "./GuestiqoGalleryBlock";
import GuestiqoCollaborationBlock, { GuestiqoCollaborationBlockProps } from "./GuestiqoCollaborationBlock";
import GuestiqoEpilogueBlock, { GuestiqoEpilogueBlockProps } from "./GuestiqoEpilogueBlock";
import MemorylayerHeroBlock, { MemorylayerHeroBlockProps } from "./MemorylayerHeroBlock";
import MemorylayerChallengeBlock, { MemorylayerChallengeBlockProps } from "./MemorylayerChallengeBlock";
import MemorylayerCompilerBlock, { MemorylayerCompilerBlockProps } from "./MemorylayerCompilerBlock";
import MemorylayerBentoBlock, { MemorylayerBentoBlockProps } from "./MemorylayerBentoBlock";
import MemorylayerCapabilitiesBlock, { MemorylayerCapabilitiesBlockProps } from "./MemorylayerCapabilitiesBlock";
import MemorylayerArchitectureBlock, { MemorylayerArchitectureBlockProps } from "./MemorylayerArchitectureBlock";
import MemorylayerTimelineBlock, { MemorylayerTimelineBlockProps } from "./MemorylayerTimelineBlock";
import MemorylayerEpilogueBlock, { MemorylayerEpilogueBlockProps } from "./MemorylayerEpilogueBlock";
import TalktribeHeroBlock, { TalktribeHeroBlockProps } from "./TalktribeHeroBlock";
import TalktribeStatsBlock, { TalktribeStatsBlockProps } from "./TalktribeStatsBlock";
import TalktribeIntroBlock, { TalktribeIntroBlockProps } from "./TalktribeIntroBlock";
import TalktribeFeaturesBlock, { TalktribeFeaturesBlockProps } from "./TalktribeFeaturesBlock";
import TalktribePreviewBlock, { TalktribePreviewBlockProps } from "./TalktribePreviewBlock";
import TalktribeHowItWorksBlock, { TalktribeHowItWorksBlockProps } from "./TalktribeHowItWorksBlock";
import TalktribeTechStackBlock, { TalktribeTechStackBlockProps } from "./TalktribeTechStackBlock";
import TalktribeCtaBlock, { TalktribeCtaBlockProps } from "./TalktribeCtaBlock";
import CtlHeroBlock, { CtlHeroBlockProps } from "./CtlHeroBlock";
import CtlOverviewBlock, { CtlOverviewBlockProps } from "./CtlOverviewBlock";
import CtlBlueprintBlock, { CtlBlueprintBlockProps } from "./CtlBlueprintBlock";
import CtlTypographyColorsBlock, { CtlTypographyColorsBlockProps } from "./CtlTypographyColorsBlock";
import CtlScreenshotBlock, { CtlScreenshotBlockProps } from "./CtlScreenshotBlock";
import CtlMobileShowcaseBlock, { CtlMobileShowcaseBlockProps } from "./CtlMobileShowcaseBlock";
import CtlValuesBlock, { CtlValuesBlockProps } from "./CtlValuesBlock";
import CtlCtaBlock, { CtlCtaBlockProps } from "./CtlCtaBlock";
import GqWebHeroBlock, { GqWebHeroBlockProps } from "./GqWebHeroBlock";
import GqWebOverviewBlock, { GqWebOverviewBlockProps } from "./GqWebOverviewBlock";
import GqWebBlueprintBlock, { GqWebBlueprintBlockProps } from "./GqWebBlueprintBlock";
import GqWebTypographyColorsBlock, { GqWebTypographyColorsBlockProps } from "./GqWebTypographyColorsBlock";
import GqWebScreenshotBlock, { GqWebScreenshotBlockProps } from "./GqWebScreenshotBlock";
import GqWebMobileShowcaseBlock, { GqWebMobileShowcaseBlockProps } from "./GqWebMobileShowcaseBlock";
import GqWebValuesBlock, { GqWebValuesBlockProps } from "./GqWebValuesBlock";
import GqWebCtaBlock, { GqWebCtaBlockProps } from "./GqWebCtaBlock";
import {
    ChronelleHeroBlock,
    ChronelleChallengeBlock,
    ChronelleWorkflowBlock,
    ChronelleShowcaseBlock,
    ChronelleCollaborationBlock,
    ChronelleArchitectureBlock,
    ChronelleRoadmapBlock,
    ChronelleCtaBlock,
    type ChronelleHeroBlockProps,
    type ChronelleChallengeBlockProps,
    type ChronelleWorkflowBlockProps,
    type ChronelleShowcaseBlockProps,
    type ChronelleCollaborationBlockProps,
    type ChronelleArchitectureBlockProps,
    type ChronelleRoadmapBlockProps,
    type ChronelleCtaBlockProps,
} from "./ChronelleBlocks";



type BaseBlock = { id?: string };

// Define the Union Type for all blocks
export type Block = BaseBlock & (
    | { type: "hero"; data: HeroBlockProps }
    | { type: "intro"; data: IntroBlockProps }
    | { type: "image-grid"; data: ImageGridBlockProps }
    | { type: "content"; data: ContentBlockProps }
    | { type: "two-column-text"; data: TwoColumnTextBlockProps }
    | { type: "product-feature"; data: ProductFeatureBlockProps }
    | { type: "carousel"; data: CarouselBlockProps }
    | { type: "brand-values"; data: BrandValuesBlockProps }
    | { type: "impact-text"; data: ImpactTextBlockProps }
    | { type: "research-header"; data: ResearchHeaderBlockProps }
    | { type: "article-section"; data: ArticleSectionBlockProps }
    | { type: "bento-grid"; data: BentoGridBlockProps }
    | { type: "hero-2"; data: AtrFlightSimBlockProps }
    | { type: "problem-solution"; data: ProblemSolutionBlockProps }
    | { type: "hero-3"; data: Hero3BlockProps }
    | { type: "about-project"; data: AboutProjectBlockProps }
    | { type: "about-project-2"; data: AboutProject2BlockProps }
    | { type: "project-gallery"; data: ProjectGalleryBlockProps }
    | { type: "project-video"; data: ProjectVideoBlockProps }
    | { type: "layout-blueprint"; data: LayoutBlueprintBlockProps }
    | { type: "typography-colors"; data: TypographyColorsBlockProps }
    | { type: "desktop-showcase"; data: DesktopShowcaseBlockProps }
    | { type: "mobile-showcase"; data: MobileShowcaseBlockProps }
    | { type: "specs-bento"; data: SpecsBentoBlockProps }
    | { type: "product-hero"; data: ProductHeroBlockProps }
    | { type: "problem-solution-cards"; data: ProblemSolutionCardsBlockProps }
    | { type: "atr-hero"; data: AtrHeroBlockProps }
    | { type: "atr-specs-dossier"; data: AtrSpecsDossierBlockProps }
    | { type: "atr-data-pipeline"; data: AtrDataPipelineBlockProps }
    | { type: "atr-parameter-grid"; data: AtrParameterGridBlockProps }
    | { type: "atr-trajectory-chart"; data: AtrTrajectoryChartBlockProps }
    | { type: "atr-epilogue"; data: AtrEpilogueBlockProps }
    | { type: "guestiqo-hero"; data: GuestiqoHeroBlockProps }
    | { type: "guestiqo-dossier"; data: GuestiqoDossierBlockProps }
    | { type: "guestiqo-lifecycle"; data: GuestiqoLifecycleBlockProps }
    | { type: "guestiqo-deliverables"; data: GuestiqoDeliverablesBlockProps }
    | { type: "guestiqo-showcase"; data: GuestiqoShowcaseBlockProps }
    | { type: "guestiqo-tech-stack"; data: GuestiqoTechStackBlockProps }
    | { type: "guestiqo-philosophy"; data: GuestiqoPhilosophyBlockProps }
    | { type: "guestiqo-timeline"; data: GuestiqoTimelineBlockProps }
    | { type: "guestiqo-metrics"; data: GuestiqoMetricsBlockProps }
    | { type: "guestiqo-gallery"; data: GuestiqoGalleryBlockProps }
    | { type: "guestiqo-collaboration"; data: GuestiqoCollaborationBlockProps }
    | { type: "guestiqo-epilogue"; data: GuestiqoEpilogueBlockProps }
    | { type: "memorylayer-hero"; data: MemorylayerHeroBlockProps }
    | { type: "memorylayer-challenge"; data: MemorylayerChallengeBlockProps }
    | { type: "memorylayer-compiler"; data: MemorylayerCompilerBlockProps }
    | { type: "memorylayer-bento"; data: MemorylayerBentoBlockProps }
    | { type: "memorylayer-capabilities"; data: MemorylayerCapabilitiesBlockProps }
    | { type: "memorylayer-architecture"; data: MemorylayerArchitectureBlockProps }
    | { type: "memorylayer-timeline"; data: MemorylayerTimelineBlockProps }
    | { type: "memorylayer-epilogue"; data: MemorylayerEpilogueBlockProps }
    | { type: "talktribe-hero"; data: TalktribeHeroBlockProps }
    | { type: "talktribe-stats"; data: TalktribeStatsBlockProps }
    | { type: "talktribe-intro"; data: TalktribeIntroBlockProps }
    | { type: "talktribe-features"; data: TalktribeFeaturesBlockProps }
    | { type: "talktribe-preview"; data: TalktribePreviewBlockProps }
    | { type: "talktribe-how-it-works"; data: TalktribeHowItWorksBlockProps }
    | { type: "talktribe-tech-stack"; data: TalktribeTechStackBlockProps }
    | { type: "talktribe-cta"; data: TalktribeCtaBlockProps }
    | { type: "ctl-hero"; data: CtlHeroBlockProps }
    | { type: "ctl-overview"; data: CtlOverviewBlockProps }
    | { type: "ctl-blueprint"; data: CtlBlueprintBlockProps }
    | { type: "ctl-typography-colors"; data: CtlTypographyColorsBlockProps }
    | { type: "ctl-screenshot"; data: CtlScreenshotBlockProps }
    | { type: "ctl-mobile-showcase"; data: CtlMobileShowcaseBlockProps }
    | { type: "ctl-values"; data: CtlValuesBlockProps }
    | { type: "ctl-cta"; data: CtlCtaBlockProps }
    | { type: "gq-web-hero"; data: GqWebHeroBlockProps }
    | { type: "gq-web-overview"; data: GqWebOverviewBlockProps }
    | { type: "gq-web-blueprint"; data: GqWebBlueprintBlockProps }
    | { type: "gq-web-typography-colors"; data: GqWebTypographyColorsBlockProps }
    | { type: "gq-web-screenshot"; data: GqWebScreenshotBlockProps }
    | { type: "gq-web-mobile-showcase"; data: GqWebMobileShowcaseBlockProps }
    | { type: "gq-web-values"; data: GqWebValuesBlockProps }
    | { type: "gq-web-cta"; data: GqWebCtaBlockProps }
    | { type: "chronelle-hero"; data: ChronelleHeroBlockProps }
    | { type: "chronelle-challenge"; data: ChronelleChallengeBlockProps }
    | { type: "chronelle-workflow"; data: ChronelleWorkflowBlockProps }
    | { type: "chronelle-showcase"; data: ChronelleShowcaseBlockProps }
    | { type: "chronelle-collaboration"; data: ChronelleCollaborationBlockProps }
    | { type: "chronelle-architecture"; data: ChronelleArchitectureBlockProps }
    | { type: "chronelle-roadmap"; data: ChronelleRoadmapBlockProps }
    | { type: "chronelle-cta"; data: ChronelleCtaBlockProps }
    | { type: "unknown"; data: any }
);

export default function BlockRenderer({ blocks }: { blocks: Block[] }) {
    return (
        <>
            {blocks.map((block, index) => {
                const FullWidthBlocks = [
                    "two-column-text",
                    "product-feature",
                    "carousel",
                    "brand-values",
                    "impact-text",
                    "research-header",
                    "article-section",
                    "bento-grid",
                    "hero-2", // Renamed from atr-flight-simulation
                    "problem-solution",
                    "hero-3",
                    "about-project",
                    "about-project-2",
                    "project-gallery",
                    "project-video",
                    "layout-blueprint",
                    "typography-colors",
                    "desktop-showcase",
                    "mobile-showcase",
                    "specs-bento",
                    "product-hero",
                    "problem-solution-cards",
                    "atr-hero",
                    "atr-specs-dossier",
                    "atr-data-pipeline",
                    "atr-parameter-grid",
                    "atr-trajectory-chart",
                    "atr-epilogue",
                    "guestiqo-hero",
                    "guestiqo-dossier",
                    "guestiqo-lifecycle",
                    "guestiqo-deliverables",
                    "guestiqo-showcase",
                    "guestiqo-tech-stack",
                    "guestiqo-philosophy",
                    "guestiqo-timeline",
                    "guestiqo-metrics",
                    "guestiqo-collaboration",
                    "guestiqo-epilogue",
                    "memorylayer-hero",
                    "memorylayer-challenge",
                    "memorylayer-compiler",
                    "memorylayer-bento",
                    "memorylayer-capabilities",
                    "memorylayer-architecture",
                    "memorylayer-timeline",
                    "memorylayer-epilogue",
                    "talktribe-hero",
                    "talktribe-stats",
                    "talktribe-intro",
                    "talktribe-features",
                    "talktribe-preview",
                    "talktribe-how-it-works",
                    "talktribe-tech-stack",
                    "talktribe-cta",
                    "ctl-hero",
                    "ctl-overview",
                    "ctl-blueprint",
                    "ctl-typography-colors",
                    "ctl-screenshot",
                    "ctl-mobile-showcase",
                    "ctl-values",
                    "ctl-cta",
                    "gq-web-hero",
                    "gq-web-overview",
                    "gq-web-blueprint",
                    "gq-web-typography-colors",
                    "gq-web-screenshot",
                    "gq-web-mobile-showcase",
                    "gq-web-values",
                    "gq-web-cta",
                    "chronelle-hero",
                    "chronelle-challenge",
                    "chronelle-workflow",
                    "chronelle-showcase",
                    "chronelle-collaboration",
                    "chronelle-architecture",
                    "chronelle-roadmap",
                    "chronelle-cta"
                ];
                const isFullWidth = FullWidthBlocks.includes(block.type);

                const BlockComponent = (() => {
                    switch (block.type) {
                        case "hero": return <HeroBlock {...block.data} />;
                        case "intro": return <IntroBlock {...block.data} />;
                        case "image-grid": return <ImageGridBlock {...block.data} />;
                        case "content": return <ContentBlock {...block.data} />;
                        case "two-column-text": return <TwoColumnTextBlock {...block.data} />;
                        case "product-feature": return <ProductFeatureBlock {...block.data} />;
                        case "carousel": return <CarouselBlock {...block.data} />;
                        case "brand-values": return <BrandValuesBlock {...block.data} />;
                        case "impact-text": return <ImpactTextBlock {...block.data} />;
                        case "research-header": return <ResearchHeaderBlock {...block.data} />;
                        case "article-section": return <ArticleSectionBlock {...block.data} />;
                        case "bento-grid": return <BentoGridBlock {...block.data} />;
                        case "hero-2": return <AtrFlightSimBlock {...block.data} />;
                        case "problem-solution": return <ProblemSolutionBlock {...block.data} />;
                        case "hero-3": return <Hero3Block {...block.data} />;
                        case "about-project": return <AboutProjectBlock {...block.data} />;
                        case "about-project-2": return <AboutProject2Block {...block.data} />;
                        case "project-gallery": return <ProjectGalleryBlock {...block.data} />;
                        case "project-video": return <ProjectVideoBlock {...block.data} />;
                        case "layout-blueprint": return <LayoutBlueprintBlock {...block.data} />;
                        case "typography-colors": return <TypographyColorsBlock {...block.data} />;
                        case "desktop-showcase": return <DesktopShowcaseBlock {...block.data} />;
                        case "mobile-showcase": return <MobileShowcaseBlock {...block.data} />;
                        case "specs-bento": return <SpecsBentoBlock {...block.data} />;
                        case "product-hero": return <ProductHeroBlock {...block.data} />;
                        case "problem-solution-cards": return <ProblemSolutionCardsBlock {...block.data} />;
                        case "atr-hero": return <AtrHeroBlock {...block.data} />;
                        case "atr-specs-dossier": return <AtrSpecsDossierBlock {...block.data} />;
                        case "atr-data-pipeline": return <AtrDataPipelineBlock {...block.data} />;
                        case "atr-parameter-grid": return <AtrParameterGridBlock {...block.data} />;
                        case "atr-trajectory-chart": return <AtrTrajectoryChartBlock {...block.data} />;
                        case "atr-epilogue": return <AtrEpilogueBlock {...block.data} />;
                        case "guestiqo-hero": return <GuestiqoHeroBlock {...block.data} />;
                        case "guestiqo-dossier": return <GuestiqoDossierBlock {...block.data} />;
                        case "guestiqo-lifecycle": return <GuestiqoLifecycleBlock {...block.data} />;
                        case "guestiqo-deliverables": return <GuestiqoDeliverablesBlock {...block.data} />;
                        case "guestiqo-showcase": return <GuestiqoShowcaseBlock {...block.data} />;
                        case "guestiqo-tech-stack": return <GuestiqoTechStackBlock {...block.data} />;
                        case "guestiqo-philosophy": return <GuestiqoPhilosophyBlock {...block.data} />;
                        case "guestiqo-timeline": return <GuestiqoTimelineBlock {...block.data} />;
                        case "guestiqo-metrics": return <GuestiqoMetricsBlock {...block.data} />;
                        case "guestiqo-gallery": return <GuestiqoGalleryBlock {...block.data} />;
                        case "guestiqo-collaboration": return <GuestiqoCollaborationBlock {...block.data} />;
                        case "guestiqo-epilogue": return <GuestiqoEpilogueBlock {...block.data} />;
                        case "memorylayer-hero": return <MemorylayerHeroBlock {...block.data} />;
                        case "memorylayer-challenge": return <MemorylayerChallengeBlock {...block.data} />;
                        case "memorylayer-compiler": return <MemorylayerCompilerBlock {...block.data} />;
                        case "memorylayer-bento": return <MemorylayerBentoBlock {...block.data} />;
                        case "memorylayer-capabilities": return <MemorylayerCapabilitiesBlock {...block.data} />;
                        case "memorylayer-architecture": return <MemorylayerArchitectureBlock {...block.data} />;
                        case "memorylayer-timeline": return <MemorylayerTimelineBlock {...block.data} />;
                        case "memorylayer-epilogue": return <MemorylayerEpilogueBlock {...block.data} />;
                        case "talktribe-hero": return <TalktribeHeroBlock {...block.data} />;
                        case "talktribe-stats": return <TalktribeStatsBlock {...block.data} />;
                        case "talktribe-intro": return <TalktribeIntroBlock {...block.data} />;
                        case "talktribe-features": return <TalktribeFeaturesBlock {...block.data} />;
                        case "talktribe-preview": return <TalktribePreviewBlock {...block.data} />;
                        case "talktribe-how-it-works": return <TalktribeHowItWorksBlock {...block.data} />;
                        case "talktribe-tech-stack": return <TalktribeTechStackBlock {...block.data} />;
                        case "talktribe-cta": return <TalktribeCtaBlock {...block.data} />;
                        case "ctl-hero": return <CtlHeroBlock {...block.data} />;
                        case "ctl-overview": return <CtlOverviewBlock {...block.data} />;
                        case "ctl-blueprint": return <CtlBlueprintBlock {...block.data} />;
                        case "ctl-typography-colors": return <CtlTypographyColorsBlock {...block.data} />;
                        case "ctl-screenshot": return <CtlScreenshotBlock {...block.data} />;
                        case "ctl-mobile-showcase": return <CtlMobileShowcaseBlock {...block.data} />;
                        case "ctl-values": return <CtlValuesBlock {...block.data} />;
                        case "ctl-cta": return <CtlCtaBlock {...block.data} />;
                        case "gq-web-hero": return <GqWebHeroBlock {...block.data} />;
                        case "gq-web-overview": return <GqWebOverviewBlock {...block.data} />;
                        case "gq-web-blueprint": return <GqWebBlueprintBlock {...block.data} />;
                        case "gq-web-typography-colors": return <GqWebTypographyColorsBlock {...block.data} />;
                        case "gq-web-screenshot": return <GqWebScreenshotBlock {...block.data} />;
                        case "gq-web-mobile-showcase": return <GqWebMobileShowcaseBlock {...block.data} />;
                        case "gq-web-values": return <GqWebValuesBlock {...block.data} />;
                        case "gq-web-cta": return <GqWebCtaBlock {...block.data} />;
                        case "chronelle-hero": return <ChronelleHeroBlock {...block.data} />;
                        case "chronelle-challenge": return <ChronelleChallengeBlock {...block.data} />;
                        case "chronelle-workflow": return <ChronelleWorkflowBlock {...block.data} />;
                        case "chronelle-showcase": return <ChronelleShowcaseBlock {...block.data} />;
                        case "chronelle-collaboration": return <ChronelleCollaborationBlock {...block.data} />;
                        case "chronelle-architecture": return <ChronelleArchitectureBlock {...block.data} />;
                        case "chronelle-roadmap": return <ChronelleRoadmapBlock {...block.data} />;
                        case "chronelle-cta": return <ChronelleCtaBlock {...block.data} />;
                        default: return null;
                    }
                })();

                if (!BlockComponent) return null;

                const theme = getHeaderTheme(block);

                return isFullWidth ? (
                    <section key={block.id || index} data-header-theme={theme} className="w-full">
                        {BlockComponent}
                    </section>
                ) : (
                    <section key={block.id || index} data-header-theme={theme} className="container mx-auto px-4 md:px-8 lg:px-12">
                        {BlockComponent}
                    </section>
                );
            })}
        </>
    );
}

function getHeaderTheme(block: Block): "dark" | "light" | undefined {
    const type = block.type;
    const data = (block as any).data;

    // Check if block data has style property
    if (data?.style) {
        const bg = data.style.backgroundColor?.toLowerCase();
        const text = data.style.textColor?.toLowerCase();
        const title = data.style.titleColor?.toLowerCase();

        // White/Light background -> Dark Header (Black Logo)
        if (bg && (bg === "#ffffff" || bg === "#fff" || bg === "white" || bg.startsWith("#fdf") || bg.startsWith("#faf") || bg.startsWith("#f8") || bg.startsWith("#f2") || bg.startsWith("#f7"))) return "dark";

        // Black/Dark text -> Dark Header
        if (text && (text === "#000000" || text === "#000" || text === "black")) return "dark";
        if (title && (title === "#000000" || title === "#000" || title === "black")) return "dark";
    }

    // Default theme based on block type family prefix
    if (type.startsWith("ctl-")) {
        return "dark"; // CTL blocks always have light backgrounds
    }
    if (type.startsWith("gq-web-")) {
        return "dark"; // Guestiqo Website blocks always have light backgrounds
    }
    if (type.startsWith("chronelle-")) {
        return ["chronelle-hero", "chronelle-workflow", "chronelle-architecture", "chronelle-cta"].includes(type)
            ? "light"
            : "dark";
    }
    if (type.startsWith("guestiqo-")) {
        if (type === "guestiqo-metrics") return "light"; // Metrics has dark bg
        return "dark"; // All other Guestiqo project blocks have light backgrounds
    }
    if (type.startsWith("atr-") || type === "hero-2") {
        return "light"; // ATR blocks have dark backgrounds
    }
    if (type.startsWith("memorylayer-")) {
        return "light"; // Memorylayer blocks have dark backgrounds
    }
    if (type.startsWith("talktribe-")) {
        return "light"; // Talktribe blocks have dark backgrounds
    }

    return undefined;
}

